import { Logo } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

export const Signature = ({ css: cssProp }: { css?: SystemStyleObject }) => {
  return (
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 380 51"
      aria-label="Betterment brand symbol with text"
      role="img"
      className={css({
        _light: { color: 'primitives.navy.100' },
        _dark: { color: 'primitives.white.100' },
        ...cssProp,
      })}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M345.767 16.001C343.802 15.9752 341.861 16.4493 340.114 17.3814C338.368 18.3135 336.871 19.6751 335.754 21.3462V16.9097H328V47H335.754V32.2724C335.754 26.6128 338.356 23.2359 342.715 23.2359C346.555 23.2359 349.303 25.8645 349.303 30.2569V47H357V28.5748C357.003 20.7142 352.411 16.001 345.767 16.001Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M269.124 46.978H260.944V30.2367C260.944 26.1024 258.357 23.2163 254.644 23.2163C250.009 23.2163 247.244 26.5928 247.244 32.2519V46.978H239V16.9002H247.244V21.3457C248.43 19.6746 250.02 18.313 251.876 17.3809C253.731 16.4488 255.793 15.9749 257.881 16.001C262.61 16.001 266.177 18.3652 267.927 22.3517C269.168 20.3908 270.909 18.7753 272.982 17.6625C275.056 16.5496 277.39 15.9773 279.758 16.001C286.589 16.001 291 20.9338 291 28.5767V47H282.824V30.2587C282.824 26.1244 280.236 23.2383 276.52 23.2383C271.889 23.2383 269.12 26.6149 269.12 32.2739L269.124 46.978Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M101.135 26.7192L99.374 26.0134L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9533 101.41 7 93.0944 7H73V47H93.1333C106.333 47 107 37.9372 107 36.1208C107.003 29.1567 101.193 26.7475 101.135 26.7192ZM81.3123 13.5814H91.2462C93.9716 13.5814 96.9074 15.1719 96.9074 18.6697C96.9074 22.0827 94.059 23.8708 91.2462 23.8708H81.3123V13.5814ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7454 98.1504 35.3334C98.1504 38.2854 95.794 40.4248 92.5474 40.4248V40.4186Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M141 32.011C140.821 22.5868 134.337 16 125.226 16C115.978 16 109.001 22.8803 109.001 32.0047C108.947 36.1807 110.531 40.2158 113.424 43.2658C116.381 46.3241 120.621 48 125.233 48C129.844 48 134.084 46.3178 137.041 43.2658C138.631 41.6079 139.832 39.6268 140.562 37.4617H133.089C131.559 40.1475 128.676 41.7761 125.233 41.7761C121.268 41.7761 118.067 38.9956 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.888 26.4845 118.911 25.0065 120.323 23.9576C121.735 22.9086 123.458 22.3471 125.226 22.3596C128.955 22.3596 131.742 24.531 132.715 28.1637H117.411Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M215 32.011C214.826 22.5868 208.546 16 199.721 16C190.759 16 184.001 22.8803 184.001 32.0047C183.95 36.1804 185.485 40.2149 188.285 43.2658C191.15 46.3241 195.257 48 199.727 48C204.197 48 208.301 46.3178 211.165 43.2658C212.705 41.6079 213.869 39.6268 214.575 37.4617H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9956 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4843 193.601 25.0061 194.97 23.9572C196.338 22.9084 198.008 22.347 199.721 22.3596C203.332 22.3596 206.032 24.531 206.974 28.1637H192.148Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M324 32.011C323.826 22.5868 317.545 16 308.719 16C299.757 16 293.001 22.8803 293.001 32.0047C292.949 36.18 294.483 40.2146 297.283 43.2658C300.15 46.3241 304.258 48 308.725 48C313.193 48 317.301 46.3178 320.165 43.2658C321.705 41.6079 322.869 39.6268 323.575 37.4617H316.327C314.845 40.1475 312.052 41.7761 308.716 41.7761C304.875 41.7761 301.775 38.9956 300.922 34.6937L300.715 33.6522H324V32.011ZM301.149 28.1637C301.609 26.4843 302.6 25.0059 303.969 23.9569C305.337 22.9079 307.006 22.3466 308.719 22.3596C312.331 22.3596 315.031 24.531 315.974 28.1637H301.149Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M237 16.0296C231.913 15.7152 227.588 17.9163 225.4 22.086V16.9069H217V47H225.4V33.9345C225.4 25.9537 231.135 21.8816 237 24.1676V16.0296Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M183.049 40.456C181.866 40.9746 180.589 41.2439 179.298 41.247C175.73 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.711 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148.001 48 155.566 48C158.518 48 161.05 47.5242 163.283 46.5442L161.331 40.4624C160.149 40.9809 158.872 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.718 48 177.286 48C180.235 48 182.768 47.5242 185 46.5442L183.049 40.456Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M378.077 40.4529C376.913 40.9714 375.656 41.2406 374.384 41.2438C370.866 41.2438 368.93 39.079 368.93 35.1463V23.093H378.426V16.9451H368.927V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.399 48C375.308 48 377.804 47.5242 380 46.5442L378.077 40.4529Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z"
        fill="#FFC729"
      />
    </svg>
  );
};

export const SignatureColorModeAware = () => (
  <>
    <Signature css={{ height: 'size.300', display: { base: 'none', md: 'block' }, minWidth: 'max-content' }} />
    <Logo type="symbol" css={{ height: 'size.300', display: { base: 'block', md: 'none' } }} />
  </>
);
